export const ALLOWED_FILE_TYPES = [
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'text/csv'
];

export const FILE_SIZE_LIMIT_IN_MO = 200;
export const FILE_SIZE_LIMIT = FILE_SIZE_LIMIT_IN_MO * 1024 * 1024; // in Mo

export const LIBELLE_MAX_LENGTH = 80;
